import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { MonarchKeyboardShortcutsMode } from "owa-outlook-service-option-store";
import getKeyboardShortcutsMode from "./getKeyboardShortcutsMode";
import shouldUseMonarchShortcuts from "./shouldUseMonarchShortcuts";

/** Applies localization only to the Outlook for Windows and Outlook for Web profiles in Monarch. */
export function shouldUseLocalizedShortcuts(): boolean {
    if (!isGlobalFeatureEnabled("cmp-localization-shortcut", true /* dontThrowErrorIfNotInitialized */) ||
        !shouldUseMonarchShortcuts()) {
        return false;
    }
    
    const keyboardShortcutsMode = getKeyboardShortcutsMode();
    return (keyboardShortcutsMode === MonarchKeyboardShortcutsMode.OutlookForWindows ||
        keyboardShortcutsMode === MonarchKeyboardShortcutsMode.OutlookForWeb);
}
